import { Alert, Stack } from "@mui/material";
import Checkbox from "../../Inputs/Checkbox";


export default function PrivatizeCheckbox({value, onChange, companyName}){

    return <Stack spacing={1}>

        <Checkbox 
            label='Privatiser la plateforme'
            value={value}
            onChange={() => onChange(!value)}
        />

        {value && 
            <Alert severity='info'>
                Les utilisateurs {companyName} ne voient que les contenus de leur entreprise (formations, posts, etc.).
            </Alert>
        }

    </Stack>
}